import { render, staticRenderFns } from "./AllLessonAllocations.vue?vue&type=template&id=741e2420&scoped=true"
import script from "./AllLessonAllocations.vue?vue&type=script&lang=js"
export * from "./AllLessonAllocations.vue?vue&type=script&lang=js"
import style0 from "./AllLessonAllocations.vue?vue&type=style&index=0&id=741e2420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e2420",
  null
  
)

export default component.exports